import { Box, Card, Checkbox, DialogTitle, FormControl, FormControlLabel, FormGroup, FormHelperText, Grid, IconButton, InputLabel, MenuItem, Select, TextField, Typography } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import { useState } from "react";
import MDButton from "components/MDButton";
import { useNavigate, useSearchParams } from "react-router-dom";
const checkboxGroup = {
    backgroundColor: "#F2F3F7",
    borderRadius: "6px",
    px: 2.5,
    py: 1,
    flexDirection: "row",
    columnGap: 3
};

export default function TemplateCreate({ closeModal }) {
    const [formData, setFormData] = useState({
        template: "",
    })
    const navigate = useNavigate()
    // const [errors, setErrors] = useState({})
    const [errors, setErrors] = useState('')



    const handleCheckboxChange = (platform) => {
        setFormData({
            ...formData,
            platformAvailability: {
                ...formData.platformAvailability,
                [platform]: !formData.platformAvailability[platform]
            }
        });
    };

    const handleSubmit = () => {
        // let errorObj = {}
        if (formData?.template === "") {
            // errorObj.template = "Template is required"
            setErrors("Template is required")
            return
        }

        navigate(`/manages/static/add?template=${formData?.template}&roleTab=hemp`)

    }

    return (
        <Card sx={{ py: 3, px: 4, borderRadius: 0 }}>
            <DialogTitle id='draggable-dialog-title' sx={{ p: 0, mb: 4 }} display='flex' alignItems='center' justifyContent='space-between'>
                Create Template
                <IconButton onClick={closeModal} edge='end' size='small' className='modal-close'>
                    <CloseIcon fontSize='medium' />
                </IconButton>
            </DialogTitle>
            <div className="create-page-template">
                <div className='select-static-pages'>
                    <Box className='filter-pro-status'>
                        <FormControl fullWidth>
                            <InputLabel>Select Static Template</InputLabel>
                            <Select size='small' value={formData?.template} onChange={(e) => { setErrors(''); setFormData({ ...formData, template: e.target.value }) }} fullWidth className='form-select' name='status' label='Product Status' >
                                <MenuItem value='about_us_template'>About Us Template</MenuItem>
                                <MenuItem value='career_template'>Career Template</MenuItem>
                                <MenuItem value='meet_the_team_template'>Meet the Team Template</MenuItem>
                                <MenuItem value='review_template'>Review Template</MenuItem>
                                <MenuItem value='pricing_template'>Pricing Template</MenuItem>
                                <MenuItem value='zipcode_template'>Delivery Zip code Template</MenuItem>
                                <MenuItem value='delivery_template'>Delivery Template</MenuItem>

                                <MenuItem value='static_template'>Static Template</MenuItem>
                                <MenuItem value='service_guarantee'>Service Guarantee</MenuItem>
                                <MenuItem value = "discreet_cannabis_delivery">Discreet Cannabis Delivery</MenuItem>
                                <MenuItem value="payments">Payments</MenuItem>
                                <MenuItem value="lab_testing_standards">Lab Testing Standards</MenuItem>
                                <MenuItem value="same_day_delivery">Same Day Delivery Page</MenuItem>
                            </Select>
                            {Boolean(errors) && <FormHelperText error>{errors}</FormHelperText>}
                        </FormControl>
                    </Box>
                </div>

                <MDButton
                    sx={{ minWidth: '160px', mt: 3 }}
                    type='button'
                    variant='contained'
                    color='primary'
                    onClick={handleSubmit}
                >
                    Create
                </MDButton>
            </div>
        </Card>
    )
}